import { useEscHandler } from "./useEscHandler"
import useOutsideAlerter from "./useOutsiderAlerter"

const useClose = (ref, doSomething) => {
  useOutsideAlerter(ref, () => doSomething())
  useEscHandler(() => doSomething())
}
export default useClose
